import { useInfiniteQuery, useQuery } from '@tanstack/react-query'

import { conversationsQueryKeys, DEFAULT_PER_PAGE } from 'api/consts'

import { fetchConversation, fetchConversations } from './api'

import type {
  FetchConversationArguments,
  FetchConversationResponse,
  FetchConversationsArguments,
} from './types'

export const useConversationsQuery = ({
  page = 1,
  limit = DEFAULT_PER_PAGE,
  query,
  enabled = true,
}: Omit<FetchConversationsArguments, 'limit'> & { limit?: number, enabled?: boolean }) =>
  useInfiniteQuery({
    getNextPageParam: ({ pagination: { currentPage, pages } }) => {
      if (currentPage < pages) {
        return currentPage + 1
      }
      return undefined
    },
    initialPageParam: 1,
    queryFn: ({ pageParam = page }: { pageParam?: number }) =>
      fetchConversations({ page: pageParam, limit, query }),
    queryKey: conversationsQueryKeys.conversationsList(query),
    enabled,
  })

export const useConversationQuery = <T = FetchConversationResponse>(
  { id }: FetchConversationArguments,
  { enabled, select }: { enabled?: boolean, select?: (data: FetchConversationResponse) => T },
) =>
  useQuery({
    enabled,
    queryKey: conversationsQueryKeys.conversationDetails(id),
    queryFn: () => fetchConversation({ id }),
    select,
  })
